<template>
  <div class="box" :class="'box_'+from">
    <span class="th cursor" @click="open"></span>
    <div class="coinex-toast" v-if="show">
      <span>这里的金币只是本节课所获取的哦</span>
      <i class="cursor" @click="close"></i>
    </div>
    
  </div>
</template>

<script>
import utils from "utils";
import common from "common";
export default {
  data() {
    return {
      show: false,
      interval:null,
    };
  },
  props:{
    from:{
      type:String,
      default:""
    }
  },
  created(){
    if(this.getCoinExShow()){
      this.open();
    }
  },
  mounted() {
    
  },
  methods: {
    getCoinExShow() {
      if (LIMI_ENV==='electron') {
        if (!utils.getNodeStorge("firstShowCoinEx")) {
          utils.setNodeStorge("firstShowCoinEx",true)
          return true;
        }
      } else {
        if (!common.get("firstShowCoinEx")) {
          common.set("firstShowCoinEx",true)
          return true;
        }
      }
      return false;
    },
    open(){
      this.show = true;
      clearTimeout(this.interval);
      this.interval = setTimeout(()=>{
        this.show = false;
      },5*1000)
    },
    close(){
      this.show = false;
      clearTimeout(this.interval);
    }
  },
};
</script>
<style scoped lang="less" rel="stylesheet/less">
.box {
  display: inline-block;
}
.th {
  display: inline-block;
  width: 18px;
  height: 18px;
  background: url("../../assets/img/common/th.png") no-repeat;
  background-size: 100%;
  margin-top: 7px;
}
.coinex-toast{
  position: absolute;
  width: 300px;
  height: 48px;
  color: #ffffff;
  line-height: 48px;
  border-radius: 24px;
  font-size: 16px;
  background: rgba(0,0,0,.4);
  right: 0px;
  top: 65px;
  display: flex;
  align-items: center;
  justify-content: center;
   &::after {
    position: absolute;
    content: " ";
    border-bottom: 8px solid  rgba(0,0,0,.4);
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    top:-8px;
    right:55px
  }
  i{
    display: inline-block;
    width: 18px;
    height:18px;
    background: url("../../assets/img/common/clear.png") no-repeat center;
    background-size: 18px;
    margin-left: 10px;
  }
}
.box_video .coinex-toast{
 top: 55px;
}
</style>


// WEBPACK FOOTER //
// src/components/basic/coinex.vue